
import React, { useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import CustomSelect from '../../components/custom-select/CustomSelect';
import * as RestService from '../../services/eisRest';
import ProcessingModal from './ProcessingModal';
import UsedBomModalWithDatatable from '../workOrder/UsedBomModalWithDatatable';

const DocumentWorkOrderOperation = (props) => {


    const [t] = useTranslation();     
    const [operation, setItem] = useState(null);
    const [active, setActive] = useState(false);
    const [workPositionList, setWorkPositionList] = useState([]);
    const [workPositionId, setWorkPositionId] = useState();
    const [resourceList, setResourceList] = useState([]);
    const [resourceId, setResourceId] = useState();
    const [bomId, setBomId] = useState(null);
    
    const [showUsedBomModalWithDatabase, setShowUsedBomModalWithDatabase] = useState(false);
    const [showProcessingModal, setShowProcessingModal] = useState(false);
    
 //   const [article, setArticle] = useState(null);
  
   
    

    const handleOpenBom = (e) => {
        setShowUsedBomModalWithDatabase(true);
    } 

    const handleOpenProcess = (e) => {
        setShowProcessingModal(true);
    }

    const handleCallbackProcessingModal = (show,id) => {         
        setShowProcessingModal(show);      
        if (typeof(id) !== 'undefined' && id != null) {       
            if(!show){
                getOperationData(id);
            }
        }
    };

    
    const handleCallbackUsedBomModalWithDatabase = (show,id) => {         
        setShowUsedBomModalWithDatabase(show);             
        //getOperationData(id);
    };
    

    

    const getOperationData = (id) => {
        RestService.callAnyApi('workOrder/getWorkOrderItem?id='+id, null)
        .then((data) => {
       //   setArticle(data); 
      
        //  operation.id=data.id;       
            
          operation.name=data.name;         
          operation.nbr=data.nbr;
          operation.numOfMachines = data.numOfMachines;
          operation.durationMachine=data.durationMachine;
          operation.numOfOperators = data.numOfOperators;
          operation.durationOperator=data.durationOperator;
          operation.description = data.description;          
          operation.resourceId = data.resourceId;
          operation.qtyOk = data.qtyOk;
          operation.qtyNok = data.qtyNok;
          setResourceId(data.resourceId);              
          if(data.resource!=null){            
            operation.machineName = data.resource.name;
            operation.costPerHourMachine = data.resource.costPerHourOfWork;
            operation.workPositionId = data.resource.workPositionId;
            setWorkPositionId(data.resource.workPositionId);                        
            if(data.resource.workPosition!=null){                
                operation.workPositionName = data.resource.workPosition.positionName;
                operation.costPerHourOperator = data.resource.workPosition.avgCostPerHour;
            }
          }
          recalcValues();
          callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const recalcValues = () => {
        if(operation!=null){            

            operation.costMachine = ((operation.costPerHourMachine* operation.numOfMachines)/60) * operation.durationMachine;
            operation.costOperator = ((operation.costPerHourOperator* operation.numOfOperators)/60) * operation.durationOperator;

        }
    }

    useEffect(() => {      
        RestService.callAnyApi('resource/getResourceProductionSelectList', null).then((data) => { setResourceList(data);  }).catch((error) => {});      
        RestService.callAnyApi('user/getWorkPositions', null).then((data) => { setWorkPositionList(data);  }).catch((error) => {});      
    }, [])

 
    useEffect(() => {         
        setItem(props.operation);      
      //  getOperationData(props.operation.id);
    }, [props.operation])

    useEffect(() => {         
        setBomId(props.bomId);      
    }, [props.bomId])

    useEffect(() => { 
        setActive(props.active);  
        if(props.active && operation){
            setResourceId(null);
            setResourceId(operation.resourceId);
            setWorkPositionId(null);
            setWorkPositionId(operation.workPositionId);
        }
    }, [props.active])

    

    const handleEdit = () => {        
        callParent("edit");
    }

    const handleCopy = () => {        
        callParent("copy");
    }

    const handleDelete = () => {        
        callParent("delete");
    }

    const callParent = (action) => {
        if(operation!=null){props.parentCallback(operation,action)}
    }

  

    const handleChange = (e,elementName) => {
      
        if(operation!=null){
            switch(elementName){
                case "name":
                    operation.operationName=e.target.value;   //text               
                break;
                case "nbr":
                    operation.nbr=e.value;    //number                       
                break;             
                case "numOfOperators":
                    operation.numOfOperators=e.value;    //number        
                    recalcValues();                  
                break;  
                case "numOfMachines":
                    operation.numOfMachines=e.value;    //number                       
                    recalcValues();   
                break;  
                case "durationMachine":
                    operation.durationMachine=e.floatValue;    //number 
                    recalcValues();                      
                break;             
                case "durationOperator":
                    operation.durationOperator=e.floatValue;    //number   
                    recalcValues();                       
                break;             
                case "costMachine":
                    operation.costMachine=e.floatValue;    //number                       
                    recalcValues();   
                break;    
                case "costOperator":
                    operation.costOperator=e.floatValue;    //number                       
                    recalcValues();   
                break;                      
                case "description":
                    operation.description=e.target.value;   //text               
                break;
            }
            callParent("update")
        }
    };

   
   
    return (

               <>                 
                    <div className="row" style={{borderRadius: '5px'}}>
    					  	      					  	  
                            <div className="col-12 col-sm-12 col-lg-12">

                                    <div className="row">

                                        <div className="col-3 col-sm-3 col-lg-3" >
  
                                                <span style={{ paddingTop: '15px', fontWeight: 'bold'}} >{operation ? operation.name : ""}</span>                                  
                                        </div>                                          

                                        <div className="col-1 col-sm-1 col-lg-1">
                                                                                             
                                                <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"  style={{ background: '#E9ECEF' }} value={operation ? operation.nbr : 0}  />                                                
                                        </div>
                                      

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator=","   style={{ background: '#E9ECEF' }} value={operation ? operation.numOfMachines : 1}  />                                                
                                        
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator=","  suffix={' min.'} style={{ background: '#E9ECEF' }} value={operation ? operation.durationMachine : 0}  />                                                
                                        
                                        </div>

                                    

                                      

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator=","   style={active ? {} : { background: '#E9ECEF' }} value={operation ? operation.numOfOperators : 1} />                                                

                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                 <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={' min.'} style={{ background: '#E9ECEF' }} value={operation ? operation.durationOperator : 0}  />                                                

                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                            <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator="," suffix={''} style={{ background: '#E9ECEF' }} value={operation ? operation.qtyOk : 0}  />                                                

                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
                                            
                                            <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="0" thousandSeparator="." decimalSeparator="," suffix={''} style={{ background: '#E9ECEF' }} value={operation ? operation.qtyNok : 0}  />                                                

                                        </div>
                                        
                                                                                          
                                                <div className="col-2 col-sm-2 col-lg-2"  style={operation && operation.id!=='' ? {  } : { display: 'none' }} >
                                                    <i className="far fa-edit" title={t('workOrder.label.process')} style={{marginTop: '15px', marginRight: '10px',color: '#009933'}} onClick={handleOpenProcess}></i>                                                    
                                                    <Link to='#' style={{ fontWeight: 'bold' }} onClick={handleOpenBom} >{t('workOrder.label.bom')}</Link>

                                                </div>
                                                
                                        </div>


                                        <div className="row" style={{marginTop: '1px'}}>

                                                <div className="col-3 col-sm-3 col-lg-3">
                                            
                                                        <span style={{ fontSize: '14px' }}>{operation ? operation.machineName : ""}</span>                                                                                                      
                                                   
                                               </div> 
                                       
                                               <div className="col-3 col-sm-3 col-lg-3">
                                               
                                               
                                               </div>
                                        </div>

                                        <div className="row" style={{marginTop: '1px'}}>

                                                    <div className="col-3 col-sm-3 col-lg-3">
                                                            
                                                            <span style={{ fontSize: '14px' }}>{operation ? operation.workPositionName : ""}</span>                                                                                                      
                                                            
                                                    </div>        
                                       
                                        </div>

                                        <div className="row" style={{marginTop: '3px'}}>

                                                <div className="col-12 col-sm-12 col-lg-12">
                                                    
                                                    <span style={{ fontSize: '14px', fontStyle: 'italic' }}>{operation ? operation.description : ""}</span>                                                                                                      
                                                                    
                                                </div>                                                                                  
                                                <div className="col-2 col-sm-2 col-lg-2"></div>	

                                        </div>

                                     
                            </div>

                   
                    </div>

                             <UsedBomModalWithDatatable
                             modal={showUsedBomModalWithDatabase}
                             parentCallback={handleCallbackUsedBomModalWithDatabase}
                             workOrderId={operation ? operation.workOrderId : ''}                      
                             operationId={operation ? operation.id : ''}                      
                             bomId={bomId}       
                             edit={false}
                             />

                            <ProcessingModal
                             modal={showProcessingModal}
                             parentCallback={handleCallbackProcessingModal}
                             workOrderId={operation ? operation.workOrderId : ''}                      
                             operationId={operation ? operation.id : ''}  
                                                
                             />
          
                </>
                   
    );

}

export default DocumentWorkOrderOperation;